import * as React from 'react';

export interface TableProps {
  className?: string;
  children: React.ReactNode;
}

export function Table({ className, children }: TableProps) {
  return (
    <div className={['table-wrap', className].filter(Boolean).join(' ')}>
      <table className="table">{children}</table>
    </div>
  );
}

export interface TableEmptyStateProps {
  title: string;
  description?: string;
}

export function TableEmptyState({ title, description }: TableEmptyStateProps) {
  return (
    <div className="table-empty">
      <div className="table-empty__title">{title}</div>
      {description ? <div className="table-empty__desc">{description}</div> : null}
    </div>
  );
}
